import React from 'react'
import classNames from 'classnames'
import { Icon, Tooltip } from '@lightspeed/design-system-react'
import { T, useT } from '@transifex/react'
import { selectCurrentSale } from '../../../../state/slices/currentSale/currentSaleSlice'
import { useAppSelector } from '../../../../state/hooks'
import { getDisabledTooltipMessage, TooltipContext } from '../add-row-tooltips'

interface DiscountLabelProps {
  disabled: boolean
  onClick: () => void
}

export const DiscountLabelLegacy: React.FC<DiscountLabelProps> = props => {
  const currentSale = useAppSelector(selectCurrentSale)
  const t = useT()
  const disabledDiscountMessage = getDisabledTooltipMessage(
    t,
    currentSale,
    TooltipContext.DISCOUNT
  )

  return (
    <Tooltip
      className="wr-tooltip"
      direction="left"
      canBeShown={props.disabled && disabledDiscountMessage !== undefined}
      header={disabledDiscountMessage?.title ?? ''}
      message={disabledDiscountMessage?.message ?? ''}
      icon="info-circle"
    >
      <span
        className={classNames(
          'vd-text-label pro-sale-discount-link sale-total-header--link',
          {
            'vd-link': !props.disabled,
            'sale-link-disabled': props.disabled,
          }
        )}
        onClick={props.onClick}
      >
        {props.disabled ? <Icon icon="fa-lock" className="vd-mr2" /> : null}{' '}
        <T _str="Discount" _context="Discount button link" />
      </span>
    </Tooltip>
  )
}
